import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';

function FilesModal({ show, onHide, files }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="files-modal"
      className="files-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="files-modal">
          Uploaded Files
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {files && files.length > 0 ? (
          <ListGroup as="ul">
            {files.map((file, index) => (
              <ListGroup.Item as="li" key={index}>
                <a 
                  href={file.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#3d95b9', textDecoration: 'underline' }}
                >
                  File {index + 1}
                </a>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <div>No files available</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default FilesModal;

